import {
  GET_BUTTON_REPAIR_VAULTING_CASH_REPLENISHMENT,
  GET_SEAL_LIST_VAULTING_CASH_REPLENISHMENT,
  GET_FINAL_SEAL_VAULTING_CASH_REPLENISHMENT,
  GET_ORDER_DETAIL_CPC_VAULTING_CASH_REPLENISHMENT,
} from 'shared/constants/ActionTypes';

const initialState = {
  buttonRepair: false,
  sealNoList: [],
  finalSeal: [],
  orderDetail: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BUTTON_REPAIR_VAULTING_CASH_REPLENISHMENT:
      return {
        ...state,
        buttonRepair: action.payload,
      };
    case GET_SEAL_LIST_VAULTING_CASH_REPLENISHMENT:
      return {
        ...state,
        sealNoList: action.payload,
      };
    case GET_FINAL_SEAL_VAULTING_CASH_REPLENISHMENT:
      return {
        ...state,
        finalSeal: action.payload,
      };
    case GET_ORDER_DETAIL_CPC_VAULTING_CASH_REPLENISHMENT:
      return {
        ...state,
        orderDetail: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
